module.exports = __webpack_public_path__ + "static/media/katie-mini.c0f672d6.jpg";